// Global Imports
import styled from "styled-components";

export const RevealButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-item: center;
  padding: 0.5rem;
`;

export const CTASpan = styled.span`
  font-weight: 300;
  font-size: 0.75rem;
  margin: 0.4rem 0.5rem 0 0;
`;

export const IconWrapper = styled.div`
  width: 24px;
  &:hover {
    cursor: pointer;
  }
`;
